<template>
    <div class="home-search-input-wrapper">
        <div class="home-search-input">
            <div class="search-area-left">

                <el-select v-model="selectValue" :placeholder="$t('请选择')" style="width: 150px">
                    <el-option value="1" :label="$t('展商')" />
                    <el-option value="2" :label="$t('展品')" />
                    <el-option value="3" :label="$t('展位号')" />
                </el-select>
            </div>
            <div class="search-input-center">
                <input v-model="searchValue" size="small" class="input" :placeholder="$t('请输入关键词搜索展商/展品')">
            </div>
            <div class="search-area-right" @click="searchClick">
                <span v-if="!mobileClient" class="el-icon-search theme-color" />
                <span class="text f-w-b">Search</span>
            </div>
        </div>
        <div class="keywords-wrapper flex fc" v-if="false">
            <div class="keywords-inner flex fs ac fw">
                <div v-for="(item, index) in productType" :key="item + index" class="keywords"
                    :class="[currentIndex === index ? 'active' : '']" @click="keywordsClick(index, item)">{{ item }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { merchant } from '@/api'
import { mapGetters } from 'vuex'

export default {
    name: 'SearchInput',
    data() {
        return {
            searchValue: '', // 输入框的值
            selectValue: '1', // 搜索框的值
            currentIndex: Number, // 分类热词下标
            productType: [ 'Christmas', 'Decor', 'Seasonal', 'Garden', 'Lighting', 'Furnitures', 'Textile', 'Wickerwork', 'Giftware' ],
            clientWidth: 1920
        }
    },
    computed: {
        mobileClient() {
            return this.clientWidth <= 750
        }
    },
    mounted() {
        // this.getData()
        this.clientWidth = document.documentElement.clientWidth
    },
    methods: {
        async getData() {
            const showType = this.getShowType()
            const res = await this.$axios.post(merchant.getProductTags, {
                showType
            })
            const { data: { questionList }} = res
        },
        // 设置showType
        getShowType() {
            let showType
            const selectValue = this.selectValue
            if (selectValue === '1') {
                showType = 'ACTOR_LIST'
            } else if (selectValue === '2') {
                showType = 'PRODUCT_LIST'
            }
            return showType
        },
        // 分类点击
        keywordsClick(index, item) {
            this.currentIndex = index
            this.func.goto({
                path: '/exhibits',
                query: {
                    questionListType: item
                }
            })
        },
        searchClick() {
            const selectValue = this.selectValue
            if (selectValue === '1' || selectValue === '3') {
                // TODO 进入展商列表
                // this.func.goto({
                //     path: '/merchant',
                //     query: {
                //         keywords: this.searchValue
                //     }
                // })
                this.$router.push({
                    path: '/find/actor',
                    query: {
                        keywords: this.searchValue
                    }
                })
            } else if (selectValue === '2') {
                // TODO 进入展品列表
                this.$router.push({
                    path: '/find/product',
                    query: {
                        keywords: this.searchValue
                    }
                })
                // this.func.goto({
                //     path: '/exhibits',
                //     query: {
                //         keywords: this.searchValue
                //     }
                // })
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.home-search-input-wrapper {
    max-width: 1366px;
    margin: 10px auto 32px;

    .home-search-input {
        width: 100%;
        height: 50px;
        padding-left: 14px;
        background: #fbfbfb;
        box-shadow: 1px 1px 1px -1px #aaaaaa;
        margin: 0 auto;
        display: flex;
        align-items: center;
        // margin-bottom: 50px;

        .search-area-left {
            display: flex;
            align-items: center;
            flex-basis: 150px;
            user-select: none;

            ::v-deep .el-icon-arrow-up::before {
                content: "";
                display: inline-block;
                width: 0px;
                height: 0px;
                border-top: 6px solid transparent;
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
                border-bottom: 8px solid;
                border-radius: 2px;
            }

            .el-icon-search {
                font-size: 18px;
                color: #443c3c;
            }

            ::v-deep .el-input__inner {
                border: 0;
                background-color: transparent;
                color: $color-main;
                font-size: 16px;
            }
        }

        .search-input-center {
            flex: 1;

            .input {
                display: inline-block;
                width: 100%;
                height: 50px;
                border: 0;
                outline: none;
                background: rgba(0, 0, 0, 0);
                font-size: 16px;

                &::placeholder {
                    color: rgba(0, 0, 0, 0.25);
                }
            }
        }

        .search-area-right {
            flex-basis: 120px;
            cursor: pointer;
            user-select: none;
            text-align: center;

            .text {
                // display: inline-block;
                // width: 100%;
                height: 22px;
                margin-left: 10px;
                text-align: center;
                // border-left: 1px solid #b9b5b5;
				color: $color-main;
                // font-weight: 600;
                font-size: 16px;
            }
        }
    }

    .keywords-wrapper {
        width: 60%;
        //height: 40px;
        margin: 20px auto;

        .keywords-inner {
            //width: 65%;
            width: 100%;
            user-select: none;

            .keywords {
                line-height: 40px;
                cursor: pointer;
                padding: 0 10px;

                &:last-child {
                    margin-right: 0;
                }

                &.active {
										color: $color-main;
                }
            }
        }
    }
}

@media screen and (max-width: 750px) {
    .home-search-input-wrapper {
        .home-search-input {
            width: 93%;
            padding-left: 0;

            .search-area-left {
                flex-basis: 100px;
            }

            .search-input-center {
                .input {
                    font-size: 14px
                }
            }

            .search-area-right {
                flex-basis: 50px;

                .text {
                    font-weight: 500;
                    font-size: 14px
                }
            }
        }

        .keywords-wrapper {
            width: 93%;

            .keywords-inner {
                padding: 0 10px;
            }
        }
    }
}
</style>
